export default class MatchGameEnum {
	static RESULT_PLAYER_1_WON = 1;
	static RESULT_PLAYER_2_WON = 2;


	static ACTION_PLAYER_1_STRIKE_STAGE = 1;
	static ACTION_PLAYER_2_STRIKE_STAGE = 2;
	static ACTION_PLAYER_1_PICK_CHARACTER = 3;
	static ACTION_PLAYER_2_PICK_CHARACTER = 4;
	static ACTION_PLAYERS_BLIND_PICK_CHARACTERS = 5;
	static ACTION_PLAYERS_PLAY_GAME = 6;
	static ACTION_PLAYER_1_PICK_STAGE = 7;
	static ACTION_PLAYER_2_PICK_STAGE = 8;
	static ACTION_GAME_OVER = 9;
	static ACTION_DISPUTED = 10;
	static ACTION_PLAYER_1_BAN_STAGE = 11;
	static ACTION_PLAYER_2_BAN_STAGE = 12;

	static ACTION_FRIENDLY_REPORT = 14;
	static ACTION_FRIENDLY_PLAY_GAME = 15;
}